import { AuthApi } from "./crud/authApi";
import { UsersApi } from "./crud/users";


/**
 * Класс-провайдер методов `api`.
 * */
export class API {
    static auth = AuthApi;
    static users = UsersApi;
}
